import EventEmitter from "events";
import agent from "vendor/ec.js";
import UUIDjs from "vendor/uuid.js";
import { Component } from "preact";
import shuffle from "lodash/shuffle";
import $ from "jquery";
import Widget from "./base.js";
import onProfileLoad from "tpm-lib/profile";

window.TPM = window.TPM || {};
window.TPM.publicOpinion = {
	render() {
		Insights.enable();
	},
};

export class Insights extends Widget {
	constructor() {
		super();
		this.state = { profile: null };

		if (Insights.enabled) this.state.enabled = true;

		Insights.onEnabled(() => {
			this.setState({ enabled: true });
		});
	}

	componentDidMount() {
		const handler = (profile) => this.setState({ profile: profile });
		onProfileLoad().then(handler, handler);
	}

	renderContent() {
		if (this.state.profile && this.state.enabled)
			return <InsightsController profile={this.state.profile} />;
		else return <div />;
	}

	static onEnabled(callback) {
		if (this._enabled) callback();
		else this._emitter.addListener("enabled", callback);
	}

	static enable() {
		this._enabled = true;
		this._emitter.emit("enabled");
	}
}

Insights._emitter = new EventEmitter();

class InsightsController extends Component {
	constructor() {
		super();
		this.state = {};
	}

	componentDidMount() {
		InsightsController.identifyAgent(this.props.profile, () => {
			InsightsController.queueFor((data) => {
				this.setState({
					queue: data,
					questionData: data,
					placeInQueue: 0,
				});
			});
		});
	}

	triggerNextQuestion() {
		this.resetContainerHeight();
		this.setState({
			placeInQueue: this.state.placeInQueue + 1, // % this.state.queue.length
		});
	}

	shuffleQuestions(questions) {
		return shuffle(questions); // put this here in case we make it more complicated
	}

	resetContainerHeight() {
		this.setState({
			containerStyle: { height: InsightsController.INITIAL_HEIGHT },
		});
	}

	resizeContainer(height) {
		this.setState({
			containerStyle: { height: height + 50 },
		});
	}

	render() {
		let iframe;
		let thankYou;
		let nextQuestion;

		if (
			this.state.queue &&
			this.state.queue.length <= this.state.placeInQueue
		) {
			thankYou = <ThankYou />;
		} else if (this.state.queue) {
			iframe = (
				<InsightsIframe
					// this is a hack, have woz change api to return https urls
					url={this.state.queue[this.state.placeInQueue].replace(
						"http:",
						"https:"
					)}
					questionData={this.state.questionData}
					nextQuestionChanger={this.triggerNextQuestion.bind(this)}
					resizeContainer={this.resizeContainer.bind(this)}
				/>
			);

			nextQuestion = (
				<NextQuestion
					nextQuestionChanger={this.triggerNextQuestion.bind(this)}
				/>
			);
		}
		return (
			<div>
				<h1 className="Insights__Header">TPM Insight</h1>
				<div
					style={this.state.containerStyle}
					className="Insights__InnerContainer"
				>
					{iframe}
					{thankYou}
					<PrivacyPolicy />
					{nextQuestion}
				</div>
			</div>
		);
	}

	static queueFor(callback) {
		$.ajax({
			url: `https://pobox.${document.location.hostname}/questions`,
			xhrFields: {
				withCredentials: true,
			},
		}).then(callback);
	}

	static ec() {
		if (this._ec) return this._ec;

		if (window.agent) {
			return (this._ec = new window.agent());
		} else return (this._ec = { get() {} });
	}

	static ecAgent(callback) {
		InsightsController.ec().get("__agent", function (uuid) {
			if (!uuid) {
				uuid = UUIDjs.create().hex;
				InsightsController.ec().set("__agent", uuid);
			}
		});
	}

	// TPM object is not available, so did not define this on an object for now
	static identifyAgent(profile, callback) {
		if (!profile.id) this.ecAgent();

		callback();
	}
}

InsightsController.INITIAL_HEIGHT = 500;

class NextQuestion extends Component {
	getNextQuestion(event) {
		event.preventDefault();
		this.props.nextQuestionChanger();
	}

	render() {
		return (
			<a
				href="#"
				onClick={this.getNextQuestion.bind(this)}
				className="Insights__NextQuestionLink"
			>
				Next Question <i class="fas fa-long-arrow-alt-right" />
			</a>
		);
	}
}

class ThankYou extends Component {
	render() {
		return (
			<div className="Insights__ThankYou">
				<div className="Insights__ThankYouText">
					<div className="Insights__ThankYouFirstLine">
						You've Answered All of The Questions
					</div>
					<div className="Insights__ThankYouSecondLine">
						Thanks For Your Input
					</div>
				</div>
			</div>
		);
	}
}

class PrivacyPolicy extends Component {
	componentDidMount() {
		$(".Insights__Privacy, .Insights__PrivacyFullTextClose").on("click", () =>
			$(".Insights__PrivacyFullText").toggle()
		);
	}
	render() {
		return (
			<div>
				<div className="Insights__Privacy">Privacy Policy</div>
				<div className="Insights__PrivacyFullText">
					<div class="Insights__PrivacyFullTextClose">X</div>
					TPM Public Opinion collects public opinion data by asking a range of
					questions of TPM Readers. We collect only aggregate opinion data. In
					other words, 65% of TPM readers say they believe X. We do not share or
					even collect answers tied to individual readers. Your answers remain
					entirely private.
				</div>
			</div>
		);
	}
}

class InsightsIframe extends Component {
	componentDidMount() {
		window.addEventListener(
			"message",
			function (event) {
				if (
					event.origin !==
					`${document.location.protocol}//pobox.${document.location.hostname}`
				)
					return;
				else this.props.resizeContainer(event.data.height);
			}.bind(this)
		);
	}

	render() {
		return (
			<iframe
				scrolling="no"
				className="Insights__Iframe"
				src={this.props.url}
			/>
		);
	}
}

// the dfp ad unit/line item handles this, allows dfp to actually track things
// window.TPM.publicOpinion.render();
